import React from "react";
import ConteudoModel from "../model/ConteudoModel";
import AppState from "../model/AppState";
import ReactDOM from "react-dom";
import NavegadorUtil from "../util/NavegadorUtil";
import { Link } from "react-router-dom";

type ConteudoItemProps = {
  item: ConteudoModel;
  parent?: React.Component;
};

class ConteudoItem extends React.Component<ConteudoItemProps, {}> {
  componentDidUpdate(): any {
    const el: any = ReactDOM.findDOMNode(this.refs.item);
    if (el && el.attributes["data-bg"]) {
      el.style.backgroundImage = `url(${el.attributes["data-bg"].value})`;
    }
  }

  componentDidMount(): any {
    const el: any = ReactDOM.findDOMNode(this.refs.item);
    if (el && el.attributes["data-bg"]) {
      el.style.backgroundImage = `url(${el.attributes["data-bg"].value})`;
    }
  }

  curtir(conteudo: ConteudoModel, evt: any): void {
    evt.preventDefault();
    const curtido: boolean = AppState.toggleCurtir(conteudo);
    NavegadorUtil.alerta(
      this.props.parent,
      curtido
        ? "Conteúdo adicionado aos favoritos"
        : "Conteúdo removido dos favoritos"
    );
  }

  render(): any {
    const { item } = this.props;

    return (
      <Link to={NavegadorUtil.getUrl(`/conteudo?conteudoId=${item.conteudoId}`)}
        draggable={false}
      >
        <div
          className="item content"
          key={item.conteudoId}
          data-bg={item.imagem}
          ref="item"
        >
          <div className="box">
            <p className="title">{item.nome}</p>
            <div className="menu">
              <p className="type">{item.tipo}</p>
              {!AppState.foiCurtido(item) && (
                <button onClick={(e) => this.curtir(item, e)}>
                  <i className="icon far fa-heart"></i>
                </button>
              )}
              {AppState.foiCurtido(item) && (
                <button onClick={(e) => this.curtir(item, e)}>
                  <i className="icon fas fa-heart"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default ConteudoItem;
